import React from 'react';

import { ArticleMode } from '../../../common/spdCore/validation/schemas';
import { useNavigation } from '../../../common/navigation';

import { ExamsSpecialistView } from './ExamsSpecialistView';

export const ExamsPsychiatristView: React.FC = () => {
  const nav = useNavigation();

  return (
    <ExamsSpecialistView
      mode="psychiatrist"
      articleMode={ArticleMode.Psychiatrist}
      tabReadyTitle={'Badania psychiatryczne do obsługi'}
      tabAllTitle={'Wszystkie badania psychiatryczne'}
      onClick={nav.examTestsPsychiatrist}
    />
  );
};
